// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2RuUm","question":"Question_question__1PS7C","description":"Question_description__3Obso"};